<template>
 <v-app>
     
  <div style="padding: 10px;" v-html="$t('messages.Privacy')" />
 </v-app>
</template>

<script>
export default {

}
</script>
 